import React from 'react';

const SvgTimeAddOpen = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.75 12C21.75 10.0716 21.1782 8.18657 20.1068 6.58319C19.0355 4.97982 17.5127 3.73013 15.7312 2.99218C13.9496 2.25422 11.9892 2.06114 10.0979 2.43735C8.20656 2.81355 6.46928 3.74215 5.10571 5.10571C3.74215 6.46928 2.81355 8.20656 2.43735 10.0979C2.06114 11.9892 2.25422 13.9496 2.99218 15.7312C3.73013 17.5127 4.97982 19.0355 6.58319 20.1068C8.18657 21.1782 10.0716 21.75 12 21.75M12 6V12H6M17.5 14V21M14 17.5H21"
        stroke="#0081FF"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SvgTimeAddOpen;
